import { api } from "./paths";
import { HospitalInfo, HospitalSurvey } from "../types/hospital";
import { SendImage } from "../pages/NurseHomepage/components/NurseGallery/types";

const axios = require("axios");

export async function getHospitals() {
  return axios.get(api.HOSPITALS_URL);
}

export async function getHospitalInfo() {
  return axios.get(api.HOSPITALINFO_URL);
}

export async function getHospitalInfoById(id: number) {
  return axios.get(`${api.HOSPITALS_URL}/${id}/info`);
}

export async function getHospitalSurvey() {
  return axios.get(api.HOSPITALSURVEY_URL);
}

export async function getHospitalSurveyById(id: number) {
  return axios.get(`${api.HOSPITALS_URL}/${id}/survey`);
}

export async function getSurveyQuestions() {
  return axios.get(api.SURVEYQUESTIONS_URL);
}

export async function getOfferedAnswers() {
  return axios.get(api.OFFEREDANSWERS_URL);
}

export async function postSurvey(survey: HospitalSurvey) {
  return axios.post(api.POSTSURVEY_URL, survey);
}

export async function getReviewComment() {
  return axios.get(api.REVIEWCOMMENT_URL);
}

export async function getHospitalPictures() {
  return axios.get(api.HOSPITALPICTURES_URL);
}

export async function addHospitalPicture(pictureBase64: SendImage) {
  return axios.post(api.ADDPICTURE_URL, pictureBase64);
}

export async function deleteHospitalPicture(imageId: number) {
  return axios.delete(api.HOSPITALPICTURES_URL + "/" + imageId);
}

export async function saveHospitalInfo(id: number, hospitalInfo: HospitalInfo) {
  return axios.put(`${api.HOSPITALS_URL}/${id}/info`, hospitalInfo);
}

export async function getRequests() {
  return axios.get(api.REVIEWREQUESTS_URL);
}

export async function getRequestByHospital(hospitalId: number) {
  return axios.get(api.REVIEWREQUESTS_URL + "/" + hospitalId);
}

export async function approvePicture(pictureId: number) {
  return axios.put(`${api.HOSPITALPICTURES_URL}/${pictureId}/approve`);
}

export async function deletePicture(pictureId: number) {
  return axios.delete(`${api.HOSPITALPICTURES_URL}/${pictureId}/delete`);
}

export async function getHospitalPicturesById(hospitalId: number) {
  return axios.get(`${api.HOSPITALPICTURES_URL}/admin/${hospitalId}`);
}

export async function addHospitalPictureById(hospitalId: number, picture: any) {
  return axios.post(`${api.HOSPITALPICTURES_URL}/admin/${hospitalId}/save`, picture);
}

export async function deleteHospitalPictureById(hospitalId: number, imageId: number) {
  return axios.delete(`${api.HOSPITALPICTURES_URL}/admin/${hospitalId}/${imageId}`);
}

export async function approveSurvey(hospitalId: number) {
  return axios.put(`${api.HOSPITALS_URL}/${hospitalId}/survey/approve`);
}

export async function rejectSurvey(hospitalId: number, explanation: string) {
  return axios.post(`${api.HOSPITALS_URL}/${hospitalId}/survey/reject`, {
    comment: explanation,
  });
}

export async function saveSurvey(
  survey: HospitalSurvey,
  hospitalId: number
) {
  return axios.post(
    `${api.HOSPITALS_URL}/${hospitalId}/survey/save`,
    survey
  );
}

export async function confirmSurvey() {
  return axios.put(api.CONFIRMSURVEY_URL);
}

export async function getServices(hospitalName: string) {
  return axios.post(api.SERVICES_URL, {name: hospitalName});
}

export function getOptionalQuestions() {
  return axios.get(api.OPTIONALQUESTIONS_URL);
}
